

let initialState = [
    {id: 5, comment: "Hallo Welt"},
    {id: 10, comment: "Hallo Welt 2"}
];

function notices(state = initialState, action) {
    if (action.type === "NOTICE_ADD") {
        let maxTodoId = 0;
        for(let todo of state) {
            if (todo.id > maxTodoId) {
                maxTodoId = todo.id;
            }
        }
        return [].concat(state, [
            { id:maxTodoId, comment: action.comment}
        ])
    }
    return state;
}

export default notices;